/**
 * Filtro responsável por formatar número de telefone estruturado
 */
angular.module("avlib").filter('avPhone', ["$filter", "phoneCodeConst", function ($filter, phoneCodeConst) {
    return function(phoneObject){
    	if (phoneObject != null){
    		if (phoneObject["country_code"] != phoneCodeConst.BRAZIL){
    			return "+"+phoneObject["country_code"]+" "+phoneObject["phone_number"];
    		}else{
    			return $filter('brPhoneNumber')(phoneObject["phone_number"]);
    		}
    	}
    	return null;
    };
}]);
